import type { Contexts, ErrorEvent } from "@sentry/react";

const REDACTED = "[Filtered]";
const SENSITIVE_KEYS = /^email_body$/i;

function redactObject(obj: Record<string, unknown>): Record<string, unknown> {
    return Object.fromEntries(
        Object.entries(obj).map(([k, v]) => [k, SENSITIVE_KEYS.test(k) ? REDACTED : v]),
    );
}

/**
 * Sentry beforeSend hook — strips email body content before it leaves the browser.
 * Extracted so it can be unit-tested without a real Sentry DSN (spec 0014 TS-6).
 */
export function sentryBeforeSend(event: ErrorEvent): ErrorEvent | null {
    if (event.extra) {
        event = { ...event, extra: redactObject(event.extra as Record<string, unknown>) };
    }

    if (event.contexts) {
        const redactedContexts: Contexts = {};
        for (const [ctxKey, ctxVal] of Object.entries(event.contexts)) {
            redactedContexts[ctxKey] =
                ctxVal && typeof ctxVal === "object"
                    ? (redactObject(ctxVal as Record<string, unknown>) as Contexts[string])
                    : ctxVal;
        }
        event = { ...event, contexts: redactedContexts };
    }

    return event;
}
